import { EntityType } from '../../../@types/entityTypes';
import SalesLedgerJournalWorkspaceQuery from '../../queries/salesLedger/SalesLedgerJournalWorkspaceQuery.graphql';
import { ALLOW_ADD } from '../../../utils/OperationPermissions';

const SalesLedgerJournal: EntityType = {
  type: 'SalesLedgerJournal',
  title: 'Sales Ledger Journals',
  workspaceUrl: '/Customers/SalesLedgerJournal/Workspace/',
  formUrl: '/Customers/SalesLedgerJournal/Details/',
  workspace: SalesLedgerJournalWorkspaceQuery,
  screenReference: 'SALES_LEDGER_JOURNALS',
  operations: ALLOW_ADD,
};

export default SalesLedgerJournal;
